import { api } from "../../components/utils/JWTAuth";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../style/styles_top3.css";

class CategoriesMultimedia extends Component {
	state = {
		categories: [],
	};
	componentDidMount() {
		//Call to webservice to get all news
		api.get("/multimedia_categories_get_all").then((res) => {
			//console.log(res);
			this.setState({
				//Just peak the last 3
				categories: res.data.records,
			});
		});
	}

	render() {
		const { categories } = this.state;

		const catNotWant = ["7"];
		let listCategory;
		if (categories.length) {
			var i = 0;
			listCategory = categories.map((categories, index) => {
				if (catNotWant.some((r) => categories.id.includes(r))) {
					return null;
				} else {
					i++;
					return (
						<li key={"cat" + index}>
							<div className="numberListing"> {("0" + i).slice(-2)}</div>
							<Link to={"/categoria-multimedia/" + categories.id}>
								{categories.name}
							</Link>
						</li>
					);
				}
			});
		}

		return (
			<div className="categoryListing">
				<h5 className="titleSidebar">Menú de categorias</h5>
				<div>
					<ul className="sidebarListingNumber">
						{listCategory ? (
							listCategory
						) : (
							<div className="center">No hay categorias</div>
						)}
					</ul>
				</div>
			</div>
		);
	}
}

export default CategoriesMultimedia;
